<script setup lang="ts">
// The closing call: the wizard cat (a paper cut-out; its candles bob) over the
// question, and the two ways in. Below the fold: the cut-out loads lazily.
import { Button } from '@/components/ui/button';
import ScrollReveal from '@/components/ui/animation/ScrollReveal.vue';
import PaperCutout from '@app/presentation/components/paper/PaperCutout.vue';
import { RouterLink } from 'vue-router';
import {
  APP_CTA_TO,
  TELEGRAM_BOT_URL,
  TELEGRAM_CTA_LABEL,
} from '@app/presentation/components/site/constants';
</script>

<template>
  <section class="relative py-16 text-center md:py-24">
    <ScrollReveal class="site-container">
      <div
        class="mx-auto mb-4 w-[170px]"
        aria-hidden="true"
      >
        <PaperCutout
          name="wizard_cat"
          lazy
        />
      </div>
      <h2 class="type-display">
        Какая карта <span class="text-primary-ink">у тебя</span><br />сегодня?
      </h2>
      <p class="mx-auto mb-8 mt-[18px] text-lg text-muted-foreground">
        Кот уже здесь — просто спроси о том, что волнует.
      </p>
      <div class="flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Button
          as-child
          size="lg"
        >
          <RouterLink :to="APP_CTA_TO">Открыть Таро Мяу 🐾</RouterLink>
        </Button>
        <Button
          as-child
          size="lg"
          variant="outline"
        >
          <a
            :href="TELEGRAM_BOT_URL"
            target="_blank"
            rel="noopener"
          >
            {{ TELEGRAM_CTA_LABEL }}
          </a>
        </Button>
      </div>
    </ScrollReveal>
  </section>
</template>
